<template>
    <div
        class="button"
        tabindex="0"
        :class="[{ round }, { loading }, type, value ? '' : 'icon-only']"
        @click="click()"
        @keyup.enter="$emit('enter')"
    >
        <FeatherIcon v-show="icon && !loading" :name="icon" />
        <div v-show="!loading" class="text copy-m bold">{{ value }}</div>
        <DLoader v-if="loading" />
    </div>
</template>

<script>
import FeatherIcon from './FeatherIcon'
import DLoader from '@/components/DLoader'

export default {
    name: 'Button',
    components: {
        FeatherIcon,
        DLoader,
    },
    props: {
        icon: {
            type: String,
        },
        value: {
            type: String,
        },
        round: {
            type: Boolean,
        },
        type: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        click() {
            // only emit the click if button is not disabled or loading
            if (!this.disabled && !this.loading) this.$emit('click')
        },
    },
}
</script>

<style scoped lang="sass">
.button
    display: inline-flex
    align-items: center
    justify-content: center
    height: 3.2rem
    border-radius: 5px
    padding: 0 1.6rem
    cursor: pointer
    outline: none
    +transition(80ms)
    user-select: none
    white-space: nowrap

    .d-loader
        width: 20px
        height: 20px

    .text
        color: currentColor
        white-space: nowrap

    ::v-deep .feather-icon
        margin-right: $xs
        width: 1.8rem
        height: 1.8rem

    &.icon-only
        padding: 0
        .feather-icon
            margin: 0
            width: 3.2em
    &.red
        background: $red
        color: white

        &::v-deep svg
            stroke: white

        &:hover, &:focus
            background: darken($red, 5%)

        &::v-deep
            .d-loader
                svg circle
                    stroke: $neutral-white


    &.primary
        background: $primary-2
        color: white

        &::v-deep svg
            stroke: white

        &:hover, &:focus
            background: darken($primary-2, 5%)

        &::v-deep
            .d-loader
                svg circle
                    stroke: $neutral-white

    &.yellow
        background: #FEC400
        color: black

        &::v-deep svg
            stroke: black

        &:hover, &:focus
            background: lighten(#FEC400, 5%)

        &::v-deep
            .d-loader
                svg circle
                    stroke: black

    &.secondary
        background: $gray-1
        color: $neutral-3

        &:hover, &:focus
            background: darken($gray-1, 5%)

        &::v-deep
            .d-loader
                svg circle
                    stroke: $neutral-3


    &.dark-secondary
        background: rgba(white, .1)
        color: white

        &::v-deep svg
            stroke: white

        &:hover, &:focus
            background: rgba(white, .05)

        &::v-deep
            .d-loader
                svg circle
                    stroke: white

    &.black
        background: black
        color: white

        &::v-deep svg
            stroke: white

        &:hover, &:focus
            background: lighten(black, 5%)

        &::v-deep
            .d-loader
                svg circle
                    stroke: white

    &.white
        background: white

        &:hover, &:focus
            background: $gray-2

        &::v-deep
            .d-loader
                svg circle
                    stroke: black

    &.link
        color: $neutral-2
        padding: 0
        .text
            @extend %copy-m
        &::v-deep svg
            stroke: $neutral-2
        &:hover, &:focus
            color: $neutral-3
            &::v-deep svg
                stroke: $neutral-3


    &.round
        border-radius: 99em
</style>
